import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Col, Row } from 'react-bootstrap';
import TableComponent from '../../../components/shared/TableComponent';

export class PendingInviteList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            options: {
                defaultSortName: 'inviteDate',
                defaultSortOrder: 'desc',
                pageStartIndex: 1,
                paginationSize: 3,
                sizePerPage: 10
            },
            title: 'Pending invites'
        };

        this.actionButtonsCellFormatter = this.actionButtonsCellFormatter.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleResendClick = this.handleResendClick.bind(this);
        this.invitedOnCellFormatter = this.invitedOnCellFormatter.bind(this);
        this.roleCellFormatter = this.roleCellFormatter.bind(this);
    }

    actionButtonsCellFormatter(cell, row) {
        return (
            <div className="updateColumn">
                <Button onClick={() => this.handleResendClick(row)}>Resend</Button>
                <Button onClick={() => this.handleCancelClick(row)}>Cancel</Button>
            </div>
        );
    }

    componentDidMount() {
        // move the pagination totals to the top of the tables
        const totals = document.querySelectorAll('.pagination-total');

        function ancestor(el, cls) {
            while ((el = el.parentElement) && !el.classList.contains(cls));
            return el;
        }

        // workaround for IE!
        Array.prototype.forEach.call(totals, el => {
            const tableContainer = ancestor(el, 'react-bs-table-container'),
                toolbar = tableContainer.querySelector('.react-bs-table-tool-bar');

            if (toolbar) toolbar.appendChild(el);
        });
    }

    componentWillReceiveProps(props) {
        if (props.invites) {
            this.setState({
                data: props.invites
            });
        }
    }

    generateTableColumns() {
        return [
            { dataField: 'username', title: 'Email', isKey: true, width: '30%', isSortable: true },
            { dataField: 'role', title: 'Role', width: '10%', dataFormat: this.roleCellFormatter },
            {
                dataField: 'inviteDate',
                title: 'Invited',
                width: '10%',
                isSortable: true,
                dataFormat: this.invitedOnCellFormatter
            },
            { dataFormat: this.actionButtonsCellFormatter, width: '25%' }
        ];
    }

    handleCancelClick(row) {
        if (this.props.onCancelInvitation) {
            this.props.onCancelInvitation(row);
        }
    }

    handleResendClick(row) {
        if (this.props.onResendInvitation) {
            this.props.onResendInvitation(row);
        }
    }

    invitedOnCellFormatter(cell, row) {
        let m = moment(row.inviteDate);
        return <div>{m.isValid() ? m.format('M/D/YYYY') : ''}</div>;
    }

    roleCellFormatter(cell, row) {
        return <div>{row.role.includes('admin') ? 'Admin' : 'Regular'}</div>;
    }

    render() {
        return (
            <TableComponent
                title={this.state.title}
                options={this.state.options}
                data={this.state.data}
                columns={this.generateTableColumns()}
            />
        );
    }
}

PendingInviteList.propTypes = {
    invites: PropTypes.array,
    onCancelInvitation: PropTypes.func,
    onResendInvitation: PropTypes.func
};
